import store from '/@/store'
import { getRoot } from '/@/root'
import { ELocalStorageKey, EDeviceTypeName } from '/@/types'
import { getDeviceBySn } from '/@/api/manage'
import { message } from 'ant-design-vue'
import dockIcon from '/@/assets/icons/dock.png'
import rcIcon from '/@/assets/icons/rc.png'
import droneIcon from '/@/assets/icons/drone.svg'
import arrowIcon from '/@/assets/icons/arrow-up-circle.svg'

import { Point, LineString } from 'ol/geom'
import { Icon, Stroke, Style } from 'ol/style'
import Feature from 'ol/Feature'
import { fromLonLat, toLonLat } from 'ol/proj'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { getVectorContext } from 'ol/render'

export function deviceTsaUpdate () {
  const root = getRoot()
  const AMap = root.$aMap

  const icons = new Map([
    [EDeviceTypeName.Aircraft, droneIcon],
    [EDeviceTypeName.Gateway, rcIcon],
    [EDeviceTypeName.Dock, dockIcon]
  ])
  const colors = new Map([
    [EDeviceTypeName.Aircraft, '#FFFFFF'], // '#3669EBFF'],
    [EDeviceTypeName.Gateway, '#4F3300FF'],
    [EDeviceTypeName.Dock, '#FFFFFF']
  ])
  const markers = store.state.markerInfo.coverMap
  const paths = store.state.markerInfo.pathMap

  interface Marker {
    x: number;
    y: number;
    lng: number;
    lat: number;
    head: number;
    speed: number;
    elevation: number;
  }

  const markerPositions: { [sn: string]: Marker[] } = {}

  const markerCurrentPosition: {
    [sn: string]: {
      x: number,
      y: number,
      head: number
    }
  } = {}

  let isMarkerMoving:boolean = false
  let markerLayer = null as any
  let routeLayer = null as any

  // const routeLayers: { [sn: string]: any } = {}
  const routeLayerLine: { [sn: string] : any} = {}
  // let trackLine = null as any

  // let trackLineCoordinates = null as any
  // let trackLineCoordinatesIndex:number = -1 // control the trackLineCoordinates array values
  // let trackLinePoints = null as any
  const default_speed = 1

  // let lerpIntervalId: number | undefined

  function lerp (start: number, end: number, t: number): number {
    let k = t / 180
    if (k > 1)k = 1
    // if (Math.abs(end - start) < 5) k = 1 // not really smooth
    // 0 => 1
    // 3 => 1/60
    return start + (end - start) * k // k = 1/60 to 1
    // return start + (end - start) / (t * 20)
  }

  function moveMarker (event?:any) {
    // const scaleHeight = 90 => 200 => 1.2
    //                     0 => 90 => 1
    if (isMarkerMoving) return

    // const mapZoom = root.$map.getView().getZoom()
    // const iconScale = (0.045 * mapZoom - 0.3)

    isMarkerMoving = true
    for (const sn in markers) {
      const markerPositionsLength = markerPositions[sn].length
      const targetPosition = markerPositions[sn][markerPositionsLength - 1]
      if (targetPosition) {
        // const target = markerTargetPosition[sn]
        // const marker = markers[sn]

        // if (target && marker) {
        //   const geometry = marker.getGeometry()
        //   const currentCoord = geometry.getCoordinates()
        //   const { x: targetX, y: targetY, head: targetHead } = target

        //   // Calculate smooth next position using linear interpolation
        //   const newX = lerp(currentCoord[0], targetX, speed)
        //   const newY = lerp(currentCoord[1], targetY, speed)

        //   // Clone and move geometry for rendering
        //   const geom = geometry.clone()
        //   geom.setCoordinates([newX, newY])

        //   // Clone and rotate style
        //   const style = marker.getStyle().clone()
        //   style.getImage().setRotation(targetHead)

        //   const vectorContext = getVectorContext(event)
        //   vectorContext.setStyle(style)
        //   vectorContext.drawGeometry(geom)

        //   // Optional: Update internal geometry if you want real position to change over time
        //   // geometry.setCoordinates([newX, newY])
        const { x, y, head, speed } = targetPosition
        // const speed_x = speed * Math.cos(head)
        // const speed_y = speed * Math.sin(head)
        // Clone current geometry
        const geom = markers[sn].getGeometry()

        const newX = lerp(markerCurrentPosition[sn].x, x, speed)
        const newY = lerp(markerCurrentPosition[sn].y, y, speed)
        const newHead = lerp(markerCurrentPosition[sn].head, head, 1)

        geom.setCoordinates([newX, newY]) // ✅ setCoordinates takes [x, y] as array

        // Clone and update style with new rotation
        const style = markers[sn].getStyle().clone()
        style.getImage().setRotation(head)

        // set icon scale
        // let elevationScale = (markerTargetPosition[sn].elevation + 20) / 100 * 15
        // if (elevationScale < 9) elevationScale = 9
        // style.getImage().setScale(elevationScale / 10)

        const vectorContext = getVectorContext(event)
        vectorContext.setStyle(style)
        vectorContext.drawGeometry(geom)
        markerCurrentPosition[sn] = { x: newX, y: newY, head: newHead }
        markers[sn].setStyle(style)
      }
    }
    isMarkerMoving = false
    // markerLayer.on('postrender', moveMarker)
    // root.$map.render()
  }

  // start the interval
  // function startInterval () {
  //   if (!lerpIntervalId) {
  //     lerpIntervalId = window.setInterval(() => {
  //       moveMarker()
  //     }, 500)
  //   }
  // }

  // // stop it from outside
  // function stopInterval () {
  //   if (lerpIntervalId) {
  //     clearInterval(lerpIntervalId)
  //     lerpIntervalId = undefined
  //   }
  // }

  // function initTrackLineFeature () {
  //   if (markerVectorSource) {
  //     if (trackLineCoordinates.length === 0) {
  //       trackLine = new Feature({
  //         geometry: new LineString([]) // empty initially
  //       })
  //     } else {
  //       trackLine = new Feature({
  //         geometry: new LineString(trackLineCoordinates)
  //       })
  //     }
  //     trackLine.setStyle(new Style({
  //       stroke: new Stroke({
  //         color: '#ffcc33ff',
  //         width: 3,
  //       }),
  //     }))
  //     markerVectorSource.addFeature(trackLine)
  //   }
  // }

  // function getTrackLineInstance () {
  //   if (!trackLine) {
  //     initTrackLineFeature()
  //     // trackLine = new AMap.Polyline({
  //     //   map: root.$map,
  //     //   strokeColor: '#939393' // 线颜色
  //     // })
  //   }

  //   return trackLine
  // }

  function updateRouteLayerline (sn: string) {
    // const trackLine = trackLines[sn]

    // trackLineCoordinatesIndex++
    // if (trackLineCoordinatesIndex < 2) {
    //   return
    // }

    // trackLineCoordinates.push(coordinate)
    // getTrackLineInstance().getGeometry().setCoordinates(trackLineCoordinates)
    const posIdx = markerPositions[sn].length - 1

    if (posIdx < 1) return

    if (posIdx > 1) {
      if (!routeLayerLine[sn]) {
        const line = new LineString([
          [markerPositions[sn][posIdx].x, markerPositions[sn][posIdx].y],
          [markerPositions[sn][posIdx - 1].x, markerPositions[sn][posIdx - 1].y]
        ])

        routeLayerLine[sn] = new Feature({
          geometry: line
        })

        routeLayerLine[sn].setStyle(new Style({
          stroke: new Stroke({
            color: '#ffcc33ff',
            width: 3,
          }),
        }))
        routeLayer.getSource().addFeature(routeLayerLine[sn])
      } else {
        const geometry = routeLayerLine[sn].getGeometry()
        geometry.appendCoordinate([markerPositions[sn][posIdx].x, markerPositions[sn][posIdx].y])
        routeLayerLine[sn].changed()
      }
    }

    const point = new Feature({
      geometry: new Point([markerPositions[sn][posIdx].x, markerPositions[sn][posIdx].y])
    })

    point.setStyle(
      new Style({
        image: new Icon({
          src: arrowIcon,
          anchor: [0.5, 0.5],
          scale: 0.25,
          rotateWithView: true,
          rotation: markerPositions[sn][posIdx].head,
        })
      })
    )

    routeLayer.getSource().addFeature(point)
  }

  // function initIcon (type: number) {
  //   // window.console.log('use-g-map-tsa initIcon:', icons.get(type))
  //   return new AMap.Icon({
  //     image: icons.get(type),
  //     imageSize: new AMap.Size(40, 40),
  //     size: new AMap.Size(40, 40)
  //   })
  // }

  function cleanRouteLayer () {
    for (const sn in markers) {
      routeLayer.getSource().clear()
      delete routeLayerLine[sn]
      const posIdx = markerPositions[sn].length - 1
      const lastMarker = markerPositions[sn][posIdx]
      markerPositions[sn] = [lastMarker]
      markerCurrentPosition[sn] = { x: lastMarker.x, y: lastMarker.y, head: lastMarker.head }
    }
  }

  function initMarker (
    type: number, name: string, sn: string, lng?: number, lat?: number, head?: number,
    elevation?: number) {
    const mapZoom = root.$map.getView().getZoom()
    const iconScale = (0.045 * mapZoom - 0.3)
    // window.console.log('use-g-map-tsa mapZoom:', mapZoom)

    // window.console.log('use-g-map-tsa initmarker')
    if (markers[sn]) {
      if (lng !== undefined && lat !== undefined) {
        const coordinate = fromLonLat([lng, lat])

        markerPositions[sn].push({ x: coordinate[0], y: coordinate[1], lng: lng, lat: lat, head: head || 0, speed: default_speed, elevation: elevation || 0 })
        markerCurrentPosition[sn] = { x: coordinate[0], y: coordinate[1], head: head || 0 }

        markers[sn].getGeometry().setCoordinates(coordinate)
        markers[sn].getStyle().getImage().setRotation(head || 0)
        markers[sn].changed()
      }
    } else {
      // if (root.$aMap === undefined) {
      //   return
      // }

      // window.console.log('use-g-map-tsa initmarker set feature')
      // Create a point feature with icon style
      // [128.31055618348088, 37.2565747455925]
      const lngIn = lng || 128.31055618348088
      const latIn = lat || 37.2565747455925
      const coordinate = fromLonLat([lngIn, latIn])

      if (sn.length > 0) {
        markers[sn] = new Feature({
          geometry: new Point(coordinate), // Initial position [lon, lat]
          name: sn,
        })

        markers[sn].setStyle(new Style({
          image: new Icon({
            anchor: [0.5, 0.5],
            src: icons.get(type),
            scale: iconScale,
            rotation: head,
            rotateWithView: true,
          })
        }))

        markerPositions[sn] = [{ x: coordinate[0], y: coordinate[1], lng: lngIn, lat: latIn, head: head || 0, speed: default_speed, elevation: elevation || 0 }]
        markerCurrentPosition[sn] = { x: coordinate[0], y: coordinate[1], head: head || 0 }

        if (!routeLayer) {
          routeLayer = new VectorLayer({
            source: new VectorSource()
          })

          root.$map.addLayer(routeLayer)
        }

        if (!markerLayer) {
          markerLayer = new VectorLayer({
            source: new VectorSource({
              features: [markers[sn]]
            })
          })

          root.$map.addLayer(markerLayer)
        } else {
          markerLayer.getSource().addFeature(markers[sn])
        }

        root.$map.render()
      }

      // if (type === EDeviceTypeName.Aircraft) {
      //   // --- 4️⃣ Add click event listener ---
      //   root.$map.on('click', function (evt: any) {
      //     // Check if user clicked on a feature
      //     root.$map.forEachFeatureAtPixel(evt.pixel, function (feature: Feature, layer: VectorLayer) {
      //       const sn = feature.get('sn')
      //       alert('You clicked on: ' + sn)
      //     })
      //   })
      // }

      // AMap = root.$aMap
      // markers[sn] = new AMap.Marker({
      //   position: new AMap.LngLat(lng || 113.943225499, lat || 22.577673716),
      //   icon: initIcon(type),
      //   title: name,
      //   anchor: 'top-center',
      //   offset: [0, -20],
      // })
      // root.$map.add(markers[sn])
      // markers[sn].on('moving', function (e: any) {
      //   let path = paths[sn]
      //   if (!path) {
      //     paths[sn] = e.passedPath
      //     return
      //   }
      //   path.push(e.passedPath[0])
      //   path.push(e.passedPath[1])
      // })
    }
  }

  function removeMarker (sn: string) {
    markerLayer.getSource().removeFeature(markers[sn])
    routeLayer.getSource().removeFeature(routeLayer[sn])
    delete routeLayerLine[sn]
    delete markers[sn]
    delete markerPositions[sn]
    delete markerCurrentPosition[sn]
    delete paths[sn]
    // stopInterval()
    // root.$map.remove(markers[sn])
    // getTrackLineInstance().setPath([])
  }

  function addMarker (sn: string, lng?: number, lat?: number, head?: number) {
    getDeviceBySn(localStorage.getItem(ELocalStorageKey.WorkspaceId)!, sn)
      .then(data => {
        if (data.code !== 0) {
          message.error(data.message)
          return
        }
        initMarker(data.data.domain, data.data.nickname, sn, lng, lat, head)
      })
  }

  function moveTo (
    sn: string,
    lng: number, lat: number,
    head?: number,
    horizontal_speed?:number, elevation?:number) {
    const marker = markers[sn]
    if (!marker) {
      addMarker(sn, lng, lat, head)
    }

    const coordinate = fromLonLat([lng, lat])
    markerPositions[sn].push({ x: coordinate[0], y: coordinate[1], head: head || 0, lng: lng, lat: lat, speed: horizontal_speed || default_speed, elevation: elevation || 0 })

    updateRouteLayerline(sn)

    markerLayer.on('postrender', moveMarker)
    // addTrackLinePoint(sn, coordinate, head || 0)
    // startInterval()
    // root.$map.getView().setCenter(coordinate)
  }

  return {
    marker: markers,
    initMarker,
    removeMarker,
    cleanRouteLayer,
    moveTo
  }
}
